export class StaffInvitationDto {
  employeeId: number;
  employeeNumber: string;
  firstName: string;
  lastName: string;
  personalEmail: string;
  merchantId: number;
  jobTitleId: number;
  departmentId: number;
  mealCards: { id: number; name: string }[];
}
